const perks = [
  { icon: "ri-medal-line", title: "國際認證", desc: "頒發 ISHB 國際證書，認可全球逾 30 個國家。" },
  { icon: "ri-team-line", title: "導師團隊", desc: "亞洲與歐美專家一對一實操教學。" },
  { icon: "ri-store-2-line", title: "開店支援", desc: "從選址、儀器到營運，全程創業輔導。" },
  { icon: "ri-customer-service-2-line", title: "終身進修", desc: "會員享終身回校進修與新技術更新。" },
];

export default function Join() {
  return (
    <section id="join" className="relative py-20 md:py-28 overflow-hidden bg-brand-50">
      {/* 柔和漸變光暈 */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-[380px] h-[380px] lg:w-[480px] lg:h-[480px] rounded-full bg-brand-200/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 -left-24 w-[340px] h-[340px] lg:w-[440px] lg:h-[440px] rounded-full bg-brand-100/70 blur-3xl"></div>
      {/* 細緻格線紋理 */}
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(31,122,82,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(31,122,82,0.06) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      ></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-block px-5 py-1.5 rounded-full border border-brand-300 text-brand-700 text-sm tracking-wider bg-white/60">導師招募</div>
          <h2 className="mt-6 font-serif text-3xl md:text-5xl text-brand-800">成為 ISHB 認證美業導師</h2>
          <p className="mt-5 text-brand-700/70">
            無論你是初學者或已是資深從業者，ISHB 都能為你提供完整的技術體系與國際舞台。
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {perks.map((p) => (
            <div key={p.title} className="p-6 rounded-lg bg-white/80 border border-brand-100 hover:border-brand-300 hover:bg-white transition">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-brand-600 text-white">
                <i className={`${p.icon} text-xl`}></i>
              </div>
              <h4 className="mt-4 font-semibold text-brand-900">{p.title}</h4>
              <p className="mt-2 text-sm text-brand-700/70 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row justify-center gap-3">
          <a
            href="https://recruit.ishb.hk"
            target="_blank"
            rel="nofollow noreferrer"
            className="px-7 py-3 rounded-md bg-brand-600 hover:bg-brand-700 text-white text-sm whitespace-nowrap cursor-pointer transition"
          >
            了解導師招募 <i className="ri-external-link-line ml-2"></i>
          </a>
          <a href="tel:+85269438757" className="px-7 py-3 rounded-md border border-brand-300 text-brand-700 hover:bg-brand-600 hover:text-white text-sm whitespace-nowrap cursor-pointer transition">
            <i className="ri-phone-line mr-2"></i>+852 6943 8757
          </a>
        </div>
      </div>
    </section>
  );
}